<template>
  <div class="wrapper">
    <!-- <div class="header">
      {{ title }}
    </div> -->
    <div class="shead">排名不分先后</div>
    <list-loadding :showloadding="showloadding">
      <lecturer-list :list="list" @listevent="listevent"></lecturer-list>
    </list-loadding>
    <footerAct></footerAct>
  </div>
</template>
<script>
import { GetArticleListBySId } from "@/api/index";
import lecturerList from "@/components/lecturer-list";
import listLoadding from "@/components/listLoadding";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      content: "",
      id: 732,
      title: "发言嘉宾",
      list: [],
      showloadding: false,
    };
  },
  computed: {
    ...mapGetters(["webSiteImageUrl"]),
  },
  components: { lecturerList, listLoadding },

  created() {
    document.title = this.title;
    this.getListById(this.id);
  },
  methods: {
    listevent(data) {
      console.log(data);
      let params = {
        id: data.N_ARTICLE_ID,
        // title: data.C_TITLE,
      };
      this.$router.push({
        path: "lectdetail",
        query: params,
      });
    },
    getListById(id) {
      let $this = this;
      this.showloadding = true;
      GetArticleListBySId(id)
        .then((res) => {
          $this.showloadding = false;
          let list = res.list;
          if (list && list.length) {
            list.forEach((item) => {
              if (item.C_LOGO)
                item.C_LOGO = $this.webSiteImageUrl + item.C_LOGO;
            });
            $this.list = list;
          }
          console.log(res);
        })
        .catch((err) => {
          $this.showloadding = false;
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  color: #fff;
}
.shead {
  margin-top: 20px;
  text-align: center;
  font-size: 13px;
  width: 100%;
  color: #fff;
}
</style>